import * as types from './mutation-types';
import { SEARCH_PARAMS, PAGING_INFO } from './state';

export default {
	[types.STATE_INIT]: state => {
		state.searchParams = SEARCH_PARAMS();
		state.pagingInfo = PAGING_INFO();
		state.resultList = [];
		state.tymaList = [];
		state.graphList = [];
		state.maxCnt = 0;
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.SEARCH_PARAM]: (state, { key, value }) => {
		state.searchParams[key] = value;
	},
	[types.PAGING_INFO]: (state, { key, value }) => {
		state.pagingInfo[key] = value;
	}
};
